export async function getBankAccount(bankAccountRepository) {
  return bankAccountRepository.get();
}
